import React, { useState, useEffect, useRef } from "react";
import {
  getAxiosResponse,
  postAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import Constants from "../../../Constants";
import { getDateAfterFormat, getLoggedInUserRole, transformBlankToNull } from "../../../services/Util";
import Select from "react-select";
import { RotatingLines } from "react-loader-spinner";
import $ from "jquery";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { useSelector} from "react-redux";
import { rolePermissionSelected } from '../../../redux/reducers/RolePermissionSlice';

export default function Permissions(prop) {
  const checkFocusRef = useRef(null);
  const userDetail = prop.user.resource;
  const [permissiondisabled, setpermissiondisabled] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [userBootstrapData, setUserBootstrapData] = useState("");
  const [eloquaAccess, setEloquaAccess] = useState("");
  const [marketoRestAccess, setMarketoRestAccess] = useState("");
  const [brightcoveAccess, setBrightcoveAccess] = useState("");
  const [pardotAccess, setPardotAccess] = useState("");
  const [vidyardAccess, setVidyardAccess] = useState("");
  const [uberflipAccess, setUberflipAccess] = useState("");
  const [responsysAccess, setResponsysAccess] = useState("");
  const [machineTranslationAccess, setMachineTranslationAccess] = useState("");
  const [exactTargetAccess, setExactTargetAccess] = useState("");
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedLangs, setSelectedLangs] = useState([]);
  const [targetLanguages, setTargetLanguage] = useState([]);
  const [filteredTargetLanguage, setFilteredTargetLanguage] = useState([]);
  const [requestAssigneeGroup, setRequestAssigneeGroup] = useState();
  const[globalOverlay,showGlobalOverlay] = useState(true);
  const [showEditButton, setShowEditButton] = useState(true)
  const unabledCheckPermission = () => {
    setpermissiondisabled(!permissiondisabled);
    setTimeout(() => {
      if(checkFocusRef.current){
      checkFocusRef.current.focus();
      }
    }, 300);
    setShowEditButton(false);
  };

  const userPermissions = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission,
  ).value;
    
    
  const roleArray = getLoggedInUserRole();
  const updatePermissions = () => {
   var userPayload = transformBlankToNull(userDetail)
   var languageLanguage = []
   postAxiosResponse(APIUrls.GET_FULL_USER_BY_ID(userDetail?.userId),userPayload)
   .then((res) => {
    setShowEditButton(true);
   })
   .catch((err) => {
     handleError(err);
   });

   selectedLangs.map((langs)=>{
    languageLanguage.push(langs.language)
  })
    var payload = {
      applicationVersion: "",
      groups: selectedDepartments,
      languages: languageLanguage,
      path: "",
    };

    var nulledPayload = transformBlankToNull(payload)

    postAxiosResponse(APIUrls.REQUEST_ASSIGNEE_GROUP(userDetail?.userId),nulledPayload).then(
      (res) => {
        prop.funct()
        getData()
        unabledCheckPermission()
      }
    );
    $('button.active').trigger('focus');
  };

  const onCancel = () => {
    setpermissiondisabled(!permissiondisabled);
    setShowEditButton(true);
    setTimeout(() => {
      $('#edit-btn').trigger('focus');
    }, 300);
  };

  const removeDepartment = (selectedDepart) => {
    var departAdd = {
      label: selectedDepart.name,
      value: selectedDepart,
    };
    if(departments.length === 0){
      setDepartments([{ label: "Select All", value: "all" }])
    }
    setDepartments((current) => [...current, departAdd]);
    setSelectedDepartments((current) =>
      current.filter((depart) => depart.id !== selectedDepart.id)
    );
   const selectedElement = $(document.activeElement).closest(".multiselect-output");
   if($(document.activeElement).is(':last-child') &&
     selectedElement.children().length > 1){
       selectedElement.find('button:nth-last-child(2)').trigger('focus');
   } else if($(document.activeElement).is(':last-child')){
     selectedElement.closest('.wrap-dropdown').find('input:first-of-type').trigger('focus');
   }
  };

  const removeLanguage = (selectedLang) => {
    var langAdd = {
      label: selectedLang.display,
      value: selectedLang,
    };
    if(filteredTargetLanguage.length === 0){
      setFilteredTargetLanguage([{ label: "Select All", value: "all" }])
    }
    setFilteredTargetLanguage((current) => [...current, langAdd]);
    setSelectedLangs((current) =>
      current.filter((lang) => lang.code !== selectedLang.code)
    );
    const selectedElement = $(document.activeElement).closest(".multiselect-output");
    if($(document.activeElement).is(':last-child') &&
      selectedElement.children().length > 1){
        selectedElement.find('button:nth-last-child(2)').trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
      selectedElement.closest('.wrap-dropdown').find('input:first-of-type').trigger('focus');
    }
  };
  const handleDepartmentSelect = (event) => {
    var selectedDepartment = event.value;
    if (selectedDepartment === "all") {
      setSelectedLangs([]);
      setDepartments([]);
      departments.map((dep) => {
        if (dep.value !== "all") {
          setSelectedDepartments((current) => [...current, dep.value]);
        }
      });
    } else {
      setDepartments((current) =>
        current.filter((depart) => depart.value.id !== selectedDepartment.id)
      );
      setSelectedDepartments((current) => [...current, selectedDepartment]);
    }
  };
  const handleLanguageSelect = (event) => {
    var langSelected = event.value;
    if (langSelected === "all") {
      setSelectedLangs([]);
      setFilteredTargetLanguage([]);
      targetLanguages.map((lang) => {
        if (lang.value !== "all") {
          setSelectedLangs((current) => [...current, lang.value]);
        }
      });
    } else {
      setFilteredTargetLanguage((current) =>
        current.filter((depart) => depart.value.code !== langSelected.code)
      );
      setSelectedLangs((current) => [...current, langSelected]);
    }
  };
  const getData = () =>{
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setUserBootstrapData(res.data.data);
    });
    

    getAxiosResponse(APIUrls.TARGET_LANGUAGE)
      .then((res) => {
        var targetLangs = [{ label: "Select All", value: "all" }];
        if (res.data.code === 200) {
          res.data.data.map((langs) => {
            targetLangs.push({
              label: langs.display,
              value: langs,
            });
          });

          setTargetLanguage(targetLangs);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }
  useEffect(() => {
    getData()
  }, []);

  useEffect(() => {
    if(userBootstrapData !== "" && userBootstrapData?.features?.PROJECT_REQUESTER) {
      getAxiosResponse(APIUrls.REQUEST_ASSIGNEE_GROUP(userDetail.userId)).then(
        (res) => {
          if(res?.data?.data !== undefined) {
            setSelectedDepartments(res.data.data.resource.groups);
            setRequestAssigneeGroup(res.data.data);
            setSelectedLangs(res.data.data.displayName[0]);
          }
        }
      );
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.ELOQUA_INTEGRATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_ELOQUA_INTEGRATION`
      ).then((res) => {
        setEloquaAccess(res.data.data);
      });
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.MARKETOREST_INTEGRATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_MARKETOREST_INTEGRATION`
      ).then((res) => {
        setMarketoRestAccess(res.data.data);
      });
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.BRIGHTCOVE_INTEGRATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_BRIGHTCOVE_INTEGRATION`
      ).then((res) => {
        setBrightcoveAccess(res.data.data);
      });
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.PARDOT_INTEGRATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_PARDOT_INTEGRATION`
      ).then((res) => {
        setPardotAccess(res.data.data);
      });
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.VIDYARD_INTEGRATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_VIDYARD_INTEGRATION`
      ).then((res) => {
        setVidyardAccess(res.data.data);
      });
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.UBERFLIP_INTEGRATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_UBERFLIP_INTEGRATION`
      ).then((res) => {
        setUberflipAccess(res.data.data);
      });
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.EXACTTARGET_INTEGRATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_EXACTTARGET_INTEGRATION`
      ).then((res) => {
        setExactTargetAccess(res.data.data);
      });
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.RESPONSYS_INTEGRATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_RESPONSYS_INTEGRATION`
      ).then((res) => {
        setResponsysAccess(res.data.data);
      });
    }
    if (
      userBootstrapData !== "" &&
      userBootstrapData?.features?.MACHINE_TRANSLATION
    ) {
      getAxiosResponse(
        APIUrls.CUSTOMER_ORG_PREFERENCE +
          `?preference=ENABLE_MACHINE_TRANSLATION`
      ).then((res) => {
        setMachineTranslationAccess(res.data.data);
      });
    }
   if(userBootstrapData !== ''){
    showGlobalOverlay(false)
   }
    
  }, [userBootstrapData]);

  useEffect(() => {
    var departs = [{ label: "Select All", value: "all" }];
    var result = [{ label: "Select All", value: "all" }];
    var filteredLangs = [{ label: "Select All", value: "all" }];
    var matchingLangs = [];
    var filteredMatch = [];


    result = userDetail?.userGroupMembers.filter(
      ({ userGroup: id1 }) =>
        !requestAssigneeGroup?.resource.groups.some(
          ({ id: id2 }) => id1.id === id2
        )
    );

    result?.map((depart) => {
      departs.push({
        label: depart.userGroup.name,
        value: depart.userGroup,
      });
    });

    setDepartments(departs);

    filteredLangs = targetLanguages.filter(
      ({ value: id1 }) =>
        !requestAssigneeGroup?.displayName[0].some(
          (id2) => id1.code === id2.code
        )
    );
    matchingLangs = targetLanguages.filter(({ value: id1 }) =>
      requestAssigneeGroup?.displayName[0].some((id2) => id1.language === id2)
    );
    matchingLangs.map((value) => {
      filteredMatch.push(value.value);
    });

    
    setFilteredTargetLanguage(filteredLangs);
  }, [userDetail, requestAssigneeGroup, permissiondisabled, targetLanguages]);

  const roleCheck = () => {
    if(userDetail.roleSet.value !== "ROLE_CUSTOMER_INTERNAL_TRANSLATOR" && userDetail.roleSet.value !== "ROLE_CUSTOMER_QUOTE_APPROVER"
      && userDetail.roleSet.value !== "ROLE_CUSTOMER_REVIEWER" && userDetail.roleSet.value !== "ROLE_CUSTOMER_PROJECT_REQUESTER") {
        return true;
      }
      return false;
  }

  return (
    <>
      <div className="inner-heading flex">
        <div className="left">
          <h4>Permissions</h4>
          <p>
            Set specific permissions for certain features. Only Administrators
            can set these permissions.
          </p>
        </div>
        <div className="flex two-col flex-center">
          

      
        {roleArray.includes('ROLE_CUSTOMER')  && userPermissions.includes("ADMINISTRATION") && showEditButton?(
          <button id="edit-btn" className="dashboard-btn" onClick={unabledCheckPermission}>
            Edit
          </button>
          ):null} 

        </div>
      </div>
      <div className="inner-permissions-tab">
        {userDetail?.permissions?.PROJECT_CUD ? (
          userBootstrapData?.features?.AUTO_APPROVE_BID ||
          userBootstrapData?.features?.ALTER_TM_UPLOAD_REQUIREMENT ? (
            <>
              <div className="permission-list">
                <h5>Requesting Quotes</h5>
                <div className="form-check small-checkbox">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="permissions.BID_AUTO_APPROVAL"
                    id="permissions.BID_AUTO_APPROVAL"
                    defaultChecked={userDetail?.permissions?.BID_AUTO_APPROVAL}
                    disabled={permissiondisabled}
                    onChange={(e)=>{
                      userDetail.permissions.BID_AUTO_APPROVAL = e.target.checked
                    }}
                    ref={checkFocusRef}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="permissions.BID_AUTO_APPROVAL"
                  >
                    Quote Auto-Approval: Can choose to automatically approve a quote
                    from a preferred vendor.
                  </label>
                </div>
                {userBootstrapData?.features?.ALTER_TM_UPLOAD_REQUIREMENT && <div className="form-check small-checkbox">
                  <input className="form-check-input" type="checkbox" name="permissions.SKIP_PROJECT_TM_UPLOAD"
                    id="permissions.SKIP_PROJECT_TM_UPLOAD" defaultChecked={userDetail?.permissions?.SKIP_PROJECT_TM_UPLOAD}
                    disabled={permissiondisabled} onChange={(e)=>{
                      userDetail.permissions.SKIP_PROJECT_TM_UPLOAD = e.target.checked
                    }}/>
                  <label className="form-check-label" htmlFor="permissions.SKIP_PROJECT_TM_UPLOAD">
                    Skip Translation Memory Upload: Can alter a project so the vendor is not required to upload Translation Memory.
                  </label>
                </div>}
              </div>
            </>
          ) : null
        ) : null}

        {userBootstrapData?.features?.TM_BROWSE_AND_EDIT && <div className="permission-list">
          <h5>Access to Translation Memory</h5>
          <div className="form-check small-checkbox">
            <input
              className="form-check-input"
              type="checkbox"
              name="permissions.TM_READ_EDIT"
              id="permissions.TM_READ_EDIT"
              disabled={permissiondisabled}
              defaultChecked={userDetail?.permissions?.TM_READ_EDIT}
              onChange={(e)=>{
                userDetail.permissions.TM_READ_EDIT = e.target.checked
              }}
            />
            <label
              className="form-check-label"
              htmlFor="permissions.TM_READ_EDIT"
            >
              Can access the Company and any Department Translation Memory,
              including the ability to edit and delete segments in any language
              pair
            </label>
          </div>
        </div>}
        <div className="permission-list">
          <h5>Access to Glossary</h5>
          <div className="form-check small-checkbox">
            <input
              className="form-check-input"
              type="checkbox"
              name="permissions.GLOSSARY_READ"
              id="permissions.GLOSSARY_READ"
              disabled={permissiondisabled}
              defaultChecked={userDetail?.permissions?.GLOSSARY_READ}
              onChange={(e)=>{
                userDetail.permissions.GLOSSARY_READ = e.target.checked
              }}
            />
            <label
              className="form-check-label"
              htmlFor="permissions.GLOSSARY_READ"
            >
              Can view company and department glossaries
            </label>
          </div>
          <div className="form-check small-checkbox">
            <input
              className="form-check-input"
              type="checkbox"
              name="permissions.GLOSSARY_EDIT"
              id="permissions.GLOSSARY_EDIT"
              disabled={permissiondisabled}
              defaultChecked={userDetail?.permissions?.GLOSSARY_EDIT}
              onChange={(e)=>{
                userDetail.permissions.GLOSSARY_EDIT = e.target.checked
              }}
            />
            <label
              className="form-check-label"
              htmlFor="permissions.GLOSSARY_EDIT"
            >
              Can edit or delete company and department glossaries
            </label>
          </div>
        </div>
        <div className="permission-list">
          <h5>Access to Style Guide</h5>
          <div className="form-check small-checkbox">
            <input
              className="form-check-input"
              type="checkbox"
              name="permissions.STYLEGUIDE_READ_EDIT"
              id="permissions.STYLEGUIDE_READ_EDIT"
              disabled={permissiondisabled}
              defaultChecked={userDetail?.permissions?.STYLEGUIDE_READ_EDIT}
              onChange={(e)=>{
                userDetail.permissions.STYLEGUIDE_READ_EDIT = e.target.checked
              }}
            />
            <label
              className="form-check-label"
              htmlFor="permissions.STYLEGUIDE_READ_EDIT"
            >
              Can view or edit the company style guide
            </label>
          </div>
        </div>
        {userBootstrapData?.features?.MARKETOREST_INTEGRATION && marketoRestAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to Marketo Rest</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.MARKETOREST_ACCESS"
                id="permissions.MARKETOREST_ACCESS"
                disabled={permissiondisabled}
                defaultChecked={userDetail?.permissions?.MARKETOREST_ACCESS}
                onChange={(e)=>{
                  userDetail.permissions.MARKETOREST_ACCESS = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.MARKETOREST_ACCESS"
              >
                Has ability to create MarketoRest integration projects
              </label>
            </div>
          </div>
        ) : null}
        {userBootstrapData?.features?.BRIGHTCOVE_INTEGRATION && brightcoveAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to Brightcove</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.BRIGHTCOVE_ACCESS"
                id="permissions.BRIGHTCOVE_ACCESS"
                disabled={permissiondisabled}
                defaultChecked={userDetail?.permissions?.BRIGHTCOVE_ACCESS}
                onChange={(e)=>{
                  userDetail.permissions.BRIGHTCOVE_ACCESS = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.BRIGHTCOVE_ACCESS"
              >
                Has ability to create Brightcove integration projects
              </label>
            </div>
          </div>
        ) : null}
        {userBootstrapData?.features?.PARDOT_INTEGRATION && pardotAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to Pardot</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.PARDOT_ACCESS"
                id="permissions.PARDOT_ACCESS"
                disabled={permissiondisabled}
                defaultChecked={userDetail?.permissions?.PARDOT_ACCESS}
                onChange={(e)=>{
                  userDetail.permissions.PARDOT_ACCESS = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.PARDOT_ACCESS"
              >
                Has ability to create Pardot integration projects
              </label>
            </div>
          </div>
        ) : null}
        {userBootstrapData?.features?.VIDYARD_INTEGRATION && vidyardAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to Vidyard</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.VIDYARD_ACCESS"
                id="permissions.VIDYARD_ACCESS"
                disabled={permissiondisabled}
                defaultChecked={userDetail?.permissions?.VIDYARD_ACCESS}
                onChange={(e)=>{
                  userDetail.permissions.VIDYARD_ACCESS = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.VIDYARD_ACCESS"
              >
                Has ability to create Vidyard integration projects
              </label>
            </div>
          </div>
        ) : null}
        {userBootstrapData?.features?.UBERFLIP_INTEGRATION && uberflipAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to Uberflip</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.UBERFLIP_ACCESS"
                id="permissions.UBERFLIP_ACCESS"
                disabled={permissiondisabled}
                defaultChecked={userDetail?.permissions?.UBERFLIP_ACCESS}
                onChange={(e)=>{
                  userDetail.permissions.UBERFLIP_ACCESS = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.UBERFLIP_ACCESS"
              >
                Has ability to create Uberflip integration projects
              </label>
            </div>
          </div>
        ) : null}
        {userBootstrapData?.features?.ELOQUA_INTEGRATION && eloquaAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to Eloqua</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.ELOQUA_ACCESS"
                id="permissions.ELOQUA_ACCESS"
                disabled={permissiondisabled}
                defaultChecked={userDetail?.permissions?.ELOQUA_ACCESS}
                onChange={(e)=>{
                  userDetail.permissions.ELOQUA_ACCESS = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.ELOQUA_ACCESS"
              >
                Has ability to create Eloqua integration projects
              </label>
            </div>
          </div>
        ) : null}
        {userBootstrapData?.features?.EXACTTARGET_INTEGRATION && exactTargetAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to ExactTarget</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.EXACTTARGET_ACCESS"
                id="permissions.EXACTTARGET_ACCESS"
                disabled={permissiondisabled}
                defaultChecked={userDetail?.permissions?.EXACTTARGET_ACCESS}
                onChange={(e)=>{
                  userDetail.permissions.EXACTTARGET_ACCESS = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.EXACTTARGET_ACCESS"
              >
                Has ability to create ExactTarget integration projects
              </label>
            </div>
          </div>
        ) : null}
        {userBootstrapData?.features?.RESPONSYS_INTEGRATION && responsysAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to Responsys</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.RESPONSYS_INTEGRATION"
                id="permissions.RESPONSYS_INTEGRATION"
                disabled={permissiondisabled}
                defaultChecked={userDetail?.permissions?.RESPONSYS_INTEGRATION}
                onChange={(e)=>{
                  userDetail.permissions.RESPONSYS_INTEGRATION = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.RESPONSYS_INTEGRATION"
              >
                Has ability to create Responsys integration projects
              </label>
            </div>
          </div>
        ) : null}
        
        {userBootstrapData?.features?.MACHINE_TRANSLATION && machineTranslationAccess.status && roleCheck() ? (
          <div className="permission-list">
            <h5>Access to Machine Translation</h5>
            <div className="form-check small-checkbox">
              <input
                className="form-check-input"
                type="checkbox"
                name="permissions.MACHINE_TRANSLATION_ACCESS"
                id="permissions.MACHINE_TRANSLATION_ACCESS"
                disabled={permissiondisabled}
                defaultChecked={
                  userDetail?.permissions?.MACHINE_TRANSLATION_ACCESS
                }
                onChange={(e)=>{
                  userDetail.permissions.MACHINE_TRANSLATION_ACCESS = e.target.checked
                }}
              />
              <label
                className="form-check-label"
                htmlFor="permissions.MACHINE_TRANSLATION_ACCESS"
              >
                Has ability to create machine translation projects
              </label>
            </div>
          </div>
        ) : null}
        {(userDetail.roleSet.value === "ROLE_CUSTOMER" || userDetail.roleSet.value === "ROLE_CUSTOMER_PROJECT_MANAGER") && <><div className="permission-list">
          <h5>Accept Translation Requests</h5>
          <p>
            Automatically receive Project Request assignments for these
            departments and languages
          </p>
          <div
            className={permissiondisabled ? "read-data show" : "read-data hide"}
          >
            {requestAssigneeGroup?.resource.groups?.length > 0 ? (
              requestAssigneeGroup?.resource.groups?.map((depart, index) => {
                if (requestAssigneeGroup?.resource.groups?.length > index + 1) {
                  return <span key={index}>{depart.name}, </span>;
                } else {
                  return <span key={index}>{depart.name} </span>;
                }
              })
            ) : (
              <span>None Selected</span>
            )}
          </div>
          <div
            className={
              permissiondisabled
                ? "flex wrap-dropdown hide"
                : "flex wrap-dropdown show"
            }
          >
            <div className="global-dropdown-block flex-center">
              <Select
                className="global-dropdown-select"
                menuShouldScrollIntoView={false}
                closeMenuOnSelect={true}
                classNamePrefix='cw'
                value={departments.filter(function (option) {
                  return option.value.id === selectedDepartments.id;
                })}
                placeholder="Select department"
                aria-label="Departments"
                options={departments}
                onChange={(e) => handleDepartmentSelect(e)}
              />
            </div>

            <div className="multiselect-output flex mar-bot16">
              {selectedDepartments.map((depart, index) => {
                return (
                  <button key={index} onClick={() => removeDepartment(depart)} aria-label={"remove "+depart.name}>
                    <strong>{depart.name}</strong>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="9"
                      viewBox="0 0 10 9"
                      fill="none"
                    >
                      <path
                        d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                        stroke="#213248"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        <div className="permission-list">
          <h5>Languages</h5>
          <div
            className={permissiondisabled ? "read-data show" : "read-data hide"}
          >
            {requestAssigneeGroup?.displayName[0]?.length > 0 ? (
              requestAssigneeGroup?.displayName[0]?.map((lang, index) => {
                if (requestAssigneeGroup?.displayName[0]?.length > index + 1) {
                  return <span key={index}>{lang.display}, </span>;
                } else {
                  return <span key={index}>{lang.display} </span>;
                }
              })
            ) : (
              <span>None Selected</span>
            )}
          </div>
          <div
            className={
              permissiondisabled
                ? "flex wrap-dropdown hide"
                : "flex wrap-dropdown show"
            }
          >
            <div className="global-dropdown-block flex-center">
              <Select
                className="global-dropdown-select"
                placeholder="Select language"
                menuShouldScrollIntoView={false}
                closeMenuOnSelect={true}
                classNamePrefix='cw'
                value={filteredTargetLanguage.filter(function (option) {
                  return option.value.code === selectedLangs.code;
                })}
                aria-label="Language"
                options={filteredTargetLanguage}
                onChange={(e) => handleLanguageSelect(e)}
              />
            </div>
            <div className="multiselect-output flex mar-bot16">
              {selectedLangs.length > 0
                ? selectedLangs?.map((lang, index) => {
                    return (
                      <button key={index} onClick={() => removeLanguage(lang)}  aria-label={"remove "+lang.display}>
                        <strong>{lang.display}</strong>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="9"
                          viewBox="0 0 10 9"
                          fill="none"
                        >
                          <path
                            d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                            stroke="#213248"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </button>
                    );
                  })
                : null}
            </div>
          </div>
        </div></>}
      </div>
      {!permissiondisabled ? (
        <div className="stricy-btn flex flex-center no-rightlist justify-end">
          <div className="left flex">
            <div>
              <button className="btn-default" onClick={onCancel}>
                Cancel
              </button>
            </div>
            <div>
              <button className="btn-default" onClick={updatePermissions}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      ) : null}
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>
    </>
  );
}
